// extracted by mini-css-extract-plugin
module.exports = {"offlinePage":"OfflinePage_offlinePage__3dQmo","logo":"OfflinePage_logo__2_IO9","info":"OfflinePage_info__2d0aA"};